import { Box, Button, Grid, LinearProgress, Typography } from "@mui/material";
import CustomCardWithBorder from "../../../components/CustomCardWithBorder";
import ViewAllButton from "../../../components/customButtons/ViewAllButton";

const ProgressBarWithLabel = ({
  label,
  value,
  max,
  color,
  icon,
  showViewAllButton,
}) => {
  return (
    <CustomCardWithBorder>
      <Grid container justifyContent="space-between" alignItems="center">
        <Grid item sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <Box width={48}> {icon}</Box>
        </Grid>
        {/* <Grid item>
          {showViewAllButton && <ViewAllButton /> }
        </Grid> */}
      </Grid>

      <Box sx={{ mt: 1 }}>
        <LinearProgress
          variant="determinate"
          value={(value / max) * 100}
          sx={{
            height: 8,
            borderRadius: 4,
            backgroundColor: "#f2f0ff",
            "& .MuiLinearProgress-bar": {
              borderRadius: 4,
              backgroundColor: color,
            },
          }}
        />
      </Box>

      <Grid
        item
        xs={12}
        mt={1}
        display="flex"
        justifyContent="space-between"
        alignItems="center"
      >
        <Typography
          fontFamily="Inter"
          fontWeight={600}
          color={color}
          fontSize="14px"
        >
          {label}
        </Typography>

        <Typography
          fontFamily="Inter"
          fontWeight={700}
          fontSize="14px"
          sx={{ color: color, mt: 0.5, cursor: "default" }}
        >
          {value.toString().padStart(2, "0")}{" "}
          <span style={{ color: "#000000" }}>
            /{max.toString().padStart(2, "0")}
          </span>
        </Typography>
      </Grid>
    </CustomCardWithBorder>
  );
};

export default ProgressBarWithLabel;
